import { SPIRIT_STONE_CLASS_CONFIGS } from "@xiuxian/game-core";

export interface WorldPoint {
  x: number;
  y: number;
}

export interface MinimapLayout {
  centerX: number;
  centerY: number;
  radius: number;
  arenaRadius: number;
}

export interface MinimapStoneStyle {
  color: number;
  alpha: number;
  radius: number;
  ringColor: number;
  ringAlpha: number;
  ringRadiusOffset: number;
}

export interface MinimapHeatmapStyle {
  color: number;
  alpha: number;
  radius: number;
  ringColor: number;
  ringAlpha: number;
}

export interface MinimapLeaderboardMarkerStyle {
  color: number;
  alpha: number;
  radius: number;
  ringColor: number;
  ringAlpha: number;
  ringRadius: number;
}

export function worldToMinimapPoint(
  point: WorldPoint,
  layout: MinimapLayout,
): WorldPoint {
  const arenaRadius = Math.max(1, layout.arenaRadius);
  const normalizedX = point.x / arenaRadius;
  const normalizedY = point.y / arenaRadius;
  const distance = Math.hypot(normalizedX, normalizedY);
  const clampScale = distance > 1 ? 1 / distance : 1;

  return {
    x: layout.centerX + normalizedX * clampScale * layout.radius,
    y: layout.centerY + normalizedY * clampScale * layout.radius,
  };
}

export function getMinimapStoneStyle(value: number): MinimapStoneStyle {
  if (value >= SPIRIT_STONE_CLASS_CONFIGS.condensed.value) {
    return {
      color: 0xb7f2ff,
      alpha: 0.58,
      radius: 2.4,
      ringColor: 0xe2fbff,
      ringAlpha: 0.28,
      ringRadiusOffset: 2,
    };
  }

  return {
    color: 0x6ae3b1,
    alpha: 0.12,
    radius: 1.15,
    ringColor: 0x6ae3b1,
    ringAlpha: 0,
    ringRadiusOffset: 0,
  };
}

export function getMinimapHeatmapStyle(
  valueSum: number,
  maxValue: number,
): MinimapHeatmapStyle {
  const value = Math.max(valueSum, maxValue);
  const isCondensed = maxValue >= SPIRIT_STONE_CLASS_CONFIGS.condensed.value;
  return {
    color: 0xb7f2ff,
    alpha: Math.min(0.72, 0.3 + Math.log10(Math.max(1, value)) * 0.07),
    radius: isCondensed ? 4.2 : 3.2,
    ringColor: 0xe2fbff,
    ringAlpha: isCondensed ? 0.36 : 0.18,
  };
}

export function getMinimapLeaderboardMarkerStyle(
  rank: number,
): MinimapLeaderboardMarkerStyle {
  if (rank === 1) {
    return {
      color: 0xfff1a8,
      alpha: 0.95,
      radius: 4.8,
      ringColor: 0xff4d2e,
      ringAlpha: 0.72,
      ringRadius: 11,
    };
  }

  return {
    color: 0xffb347,
    alpha: 0.82,
    radius: 3.5,
    ringColor: 0xffd166,
    ringAlpha: 0.42,
    ringRadius: 7.5,
  };
}
